import React from "react";

import classNames from "classnames";
import ReactCanvasConfetti from "react-canvas-confetti";

interface Props {
    className?: string;
    fire: number;
}

const RecognitionConfetti = ({ className, fire }: Props) => {
    const classes = classNames(
        "recognition-confetti",
        className
    );

    return (
        <ReactCanvasConfetti
            className={classes}
            style={{ width: 1000, height: "100%" }}
            fire={fire}
            angle={90}
            colors={[
                "#BBEFE4",
                "#FFA878",
                "#FDDE88",
                "#FFC3BA",
                "#95B3FE",
                "#E5F4FB"
            ]}
            decay={0.91}
            drift={0}
            gravity={1}
            origin={{
                x: 0.5,
                y: 0.5
            }}
            particleCount={40}
            scalar={1.5}
            shapes={[
                "square"
            ]}
            spread={160}
            startVelocity={25}
            ticks={400}
            useWorker
            resize
        />
    );
};

export default RecognitionConfetti;